export var help = {
    900: '#2A4689',
    800: '#3562A9',
    700: '#3C73BB',
    600: '#4484CE',
    500: '#4B92DB',
    400: '#5CA1E1',
    300: '#74B1E5',
    200: '#98C7EE',
    100: '#BFDCF4',
    50: '#E4F1FA',
};
//# sourceMappingURL=help.js.map